export const formatLabel = (label) => {
  return label.replace(/_/g, ' ').replace(/(\b[a-z](?!\s))/g, function (x) {
    return x.toUpperCase();
  });
};

export const removeDotsAndQuotesFromString = (str) => {
  return str.replace(/[’.‘]/g, '');
};
